import { useEffect, useState, useRef } from "react";
import { PlayerConfig, SourceConfig } from "bitmovin-player";
import { BitmovinPlayer } from "bitmovin-player-react";
import "bitmovin-player-ui/dist/css/bitmovinplayer-ui.css";
import { useApi } from '../../../../context/ApiContext/ApiContext';
import { Redo } from 'lucide-react';

const playerConfig = {
  key: "f7c712b2-e9c9-40bc-8e87-fe573b50fea0", // Replace with your valid Bitmovin Player license key
  playback: {
    muted: true,
    autoplay: true,
  },
  ui: {
    playback: {
      pictureInPicture: true,
    },
    container: undefined
  },
  style: {
    uxControls: true,
  }
};

// Add custom CSS for the blur effect
const styles = `
  .blurred-border {
    position: relative;
  }
  
  .blurred-border::before {
    content: "";
    position: absolute;
    top: -8px;
    left: -8px;
    right: -8px;
    bottom: -8px;
    z-index: -1;
    background: rgba(59, 130, 246, 0.5); /* Blue with transparency */
    filter: blur(10px);
    border-radius: 12px;
  }
  
  /* Make the player responsive */
  .bmpui-ui-container, 
  .bmpui-ui-uicontainer, 
  .bitmovinplayer-container,
  .bitmovinplayer-container > div,
  .bitmovinplayer-container > div > div {
    width: 100% !important;
    height: 100% !important;
  }
  
  /* Styles for reload button */
  .player-reload-btn {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.2s ease;
  }
  
  .player-reload-btn:hover {
    opacity: 1;
  }
`;

const BitmovinPlayerModule = () => {
  const { state, updateSharedParams } = useApi();
  // const [bitmovinPlayerURL, setBitmovinPlayerURL] = useState({"hls": null});
  const [ bitmovinPlayerURL, setBitmovinPlayerURL ] = useState(undefined);
  const [ hasValidUrl, setHasValidUrl ] = useState(false);
  const [ playerKey, setPlayerKey ] = useState(Date.now()); // Used to force remount
  const playerRef = useRef(null);

  const PLAYER_DELAY_MS = 0;
  const [ showAfterDelay, setShowAfterDelay ] = useState(false);

  useEffect(() => {
    console.log("______________");
    console.log("hasValidUrl: ", hasValidUrl);
    console.log("state.sharedParams.playerURL: ", state.sharedParams.playerURL);
    console.log("state.sharedParams.isPlayerURLReady: ", state.sharedParams.isPlayerURLReady);
    console.log("______________");

  }, [hasValidUrl])
  
  useEffect(() => {
    if (state.sharedParams?.playerURL && state.sharedParams.playerURL.length > 0 && state.sharedParams.isPlayerURLReady) {
      console.log('___state.playerURL', state.sharedParams.playerURL);
      const url = state.sharedParams.playerURL;
      setBitmovinPlayerURL({ hls: url });
      setHasValidUrl(true);

    } else {
      setHasValidUrl(false);
    }
  }, [state.sharedParams?.playerURL, state.sharedParams.isPlayerURLReady]);

  // Set up player API and event listeners
  // useEffect(() => {
  //   if (!playerRef.current || !hasValidUrl) return;
    
  //   const player = playerRef.current.instance;
  //   if (!player) return;
    
  //   // Function to collect and update player metrics
  //   const updatePlayerMetrics = () => {
  //     try {
  //       // Basic playback metrics
  //       const isPlaying = !player.isPaused();
  //       const currentTime = player.getCurrentTime() || 0;
  //       const duration = player.getDuration() || 0;
        
  //       // Video quality metrics
  //       let currentBitrate = null;
  //       let bitrateLadder = [];
        
  //       const videoData = player.getPlaybackVideoData();
  //       if (videoData) {
  //         currentBitrate = videoData.bitrate;
  //       }
        
  //       const availableQualities = player.getAvailableVideoQualities();
  //       if (availableQualities && availableQualities.length) {
  //         bitrateLadder = availableQualities.map(quality => ({
  //           id: quality.id,
  //           bitrate: quality.bitrate,
  //           width: quality.width,
  //           height: quality.height
  //         }));
  //       }
        
  //       // Update state with collected metrics
  //       updateSharedParams({
  //         playerMetrics: {
  //           isPlaying,
  //           currentTime,
  //           duration,
  //           progress: duration > 0 ? (currentTime / duration) * 100 : 0,
  //           currentBitrate,
  //           bitrateLadder,
  //           isBuffering: player.isStalled(),
  //           volume: player.getVolume(),
  //           isMuted: player.isMuted(),
  //         }
  //       });
  //     } catch (error) {
  //       console.error("Error updating player metrics:", error);
  //     }
  //   };
    
  //   // Define player events to listen for
  //   const events = [
  //     'play', 'pause', 'playing', 'playbackfinished', 
  //     'ready', 'stalling', 'stallended',
  //     'videoplaybackqualitychanged'
  //   ];
    
  //   // Register all event listeners
  //   events.forEach(event => {
  //     player.on(event, updatePlayerMetrics);
  //   });
    
  //   // Initial metrics update
  //   updatePlayerMetrics();
    
  //   // Set up interval for periodic updates (for time-based metrics)
  //   const metricsInterval = setInterval(updatePlayerMetrics, 1000);
    
  //   // Cleanup function
  //   return () => {
  //     // Remove all event listeners
  //     if (player && !player.isDestroyed()) {
  //       events.forEach(event => {
  //         player.off(event, updatePlayerMetrics);
  //       });
        
  //       clearInterval(metricsInterval);
  //     }
  //   };
  // }, [playerRef.current, hasValidUrl]);
  useEffect(() => {
    console.log("useEffect - if (!playerRef.current || !hasValidUrl) return");
    if (!playerRef.current || !hasValidUrl) return;
    console.log("WITHIN > useEffect - if (!playerRef.current");
    
    let metricsInterval;
    
    // Function to safely get current player instance
    const getPlayerInstance = () => {
      console.log("getPlayerInstance");
      return playerRef.current?.instance && !playerRef.current.instance.isDestroyed() 
        ? playerRef.current.instance 
        : null;
    };
    
    // Function to collect and update player metrics
    const updatePlayerMetrics = () => {
      console.log("updatePlayerMetrics: ", "GOT HERE");
      const player = getPlayerInstance();
      if (!player) {
        clearInterval(metricsInterval);
        return;
      }
      
      try {
        // Basic playback metrics
        const isPlaying = !player.isPaused();
        const currentTime = player.getCurrentTime() || 0;
        const duration = player.getDuration() || 0;
        
        // Video quality metrics
        let currentBitrate = null;
        let bitrateLadder = [];
        
        const videoData = player.getPlaybackVideoData();
        console.log("videoData", videoData);
        if (videoData) {
          currentBitrate = videoData.bitrate;
        }
        
        const availableQualities = player.getAvailableVideoQualities();
        if (availableQualities && availableQualities.length) {
          bitrateLadder = availableQualities.map(quality => ({
            id: quality.id,
            bitrate: quality.bitrate,
            width: quality.width,
            height: quality.height
          }));
        }
        
        updateSharedParams({
          playerMetrics: {
            isPlaying,
            currentTime,
            duration,
            progress: duration > 0 ? (currentTime / duration) * 100 : 0,
            currentBitrate,
            bitrateLadder,
            isBuffering: player.isStalled(),
            volume: player.getVolume(),
            isMuted: player.isMuted(),
          }
        });
      } catch (error) {
        console.error("Error updating player metrics:", error);
        clearInterval(metricsInterval);
      }
    };
    
    // Register events only if player exists
    const player = getPlayerInstance();
    if (player) {
      const events = ['play', 'pause', 'playing', 'playbackfinished', 
                      'ready', 'stalling', 'stallended',
                      'videoplaybackqualitychanged'];
                      
      events.forEach(event => {
        player.on(event, updatePlayerMetrics);
      });
      
      // Initial metrics update
      updatePlayerMetrics();
      
      // Set up interval for periodic updates
      metricsInterval = setInterval(updatePlayerMetrics, 1000);
      
      // Cleanup function
      return () => {
        clearInterval(metricsInterval);
        
        // Only try to remove listeners if player still exists
        const currentPlayer = getPlayerInstance();
        if (currentPlayer) {
          events.forEach(event => {
            currentPlayer.off(event, updatePlayerMetrics);
          });
        }
      };
    }
  }, [playerRef.current, hasValidUrl]);
  
  // Ensure player is properly destroyed on unmount
  useEffect(() => {
    return () => {
      if (playerRef.current?.instance && !playerRef.current.instance.isDestroyed()) {
        playerRef.current.instance.destroy();
      }
    };
  }, []);
  
  // Function to reload the player by forcing a remount
  const handleReloadPlayer = () => {
    // First destroy the current instance if it exists
    if (playerRef.current?.instance && !playerRef.current.instance.isDestroyed()) {
      playerRef.current.instance.destroy();
    }
    
    // Generate a new key to force React to remount the component
    setPlayerKey(Date.now());
    
    // Log for debugging
    console.log('Player reloaded');
  };

  // Add this useEffect for the delay
  useEffect(() => {
    if (hasValidUrl) {
      const timer = setTimeout(() => {
        setShowAfterDelay(true);
      }, PLAYER_DELAY_MS);
      
      return () => clearTimeout(timer);
    } else {
      setShowAfterDelay(false);
    }
  }, [hasValidUrl]);

  return (
    <>
      <style>{styles}</style>
      
      <div 
        // className={`flex items-center justify-center blurred-border relative w-[330px] h-[190px] ${!hasValidUrl && !showAfterDelay ? "hidden" : "" } ? "hidden" : ""}`}
        className={`flex items-center justify-center blurred-border relative w-[330px] h-[190px] ${!(hasValidUrl && showAfterDelay) ? "hidden" : ""}`}
      >
        {/* Reload button */}
        <div className="player-reload-btn" onClick={handleReloadPlayer}>
          <Redo size={16} color="#FFFFFF" />
        </div>
        
        <div className="w-full h-full">
          {hasValidUrl && showAfterDelay && (
            <BitmovinPlayer 
              key={playerKey} // This forces React to remount when changed
              ref={playerRef}
              config={playerConfig} 
              source={bitmovinPlayerURL}
              style={{
                width: '100%',
                height: '100%'
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BitmovinPlayerModule;